import {Outlet} from 'react-router-dom';
import EpisodeHeader from './components/EpisodeHeader';
import styles from './EpisodeLayout.module.less';

const EpisodeLayout: React.FC = () => {
    return (
        <div className={styles.episodeLayout}>
            <EpisodeHeader />
            <main className={styles.episodeContent}>
                <Outlet />
            </main>
        </div>
    );
};

export default EpisodeLayout;
